import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "fixed top-0 left-0 w-screen h-screen flex justify-center items-center",
  style: {"z-index":"990"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 left-0 w-full h-full bg-black opacity-50" }, null, -1)
const _hoisted_3 = {
  class: "relative",
  style: {"z-index":"999"}
}

import LoadingCircle from './LoadingCircle.vue';
import { onMounted, onUnmounted } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'DimmedLoading',
  setup(__props) {

onMounted(() => {
      document.body.style.overflow = 'hidden';
    });

onUnmounted(()=> {
    document.body.style.overflow = 'auto';

})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(LoadingCircle)
    ])
  ]))
}
}

})